import { VpIcon } from '@vtmn-play/react'
import ProgressCircle from 'components/common/progress-circle/progress-circle'

interface WeeklyGmvProgressCircleProps {
  targetPercent: number
  unavailable?: boolean
}

const WeeklyGmvProgressCircle = ({ targetPercent, unavailable = false }: WeeklyGmvProgressCircleProps) => (
  <ProgressCircle rate={Math.round(targetPercent)} color="blue" fullColor="green" unavailable={unavailable}>
    <span className="mg-weekly-gmv-progress-icon">
      <VpIcon {...({ name: 'store', size: 40 } as any)} />
    </span>
  </ProgressCircle>
)

export default WeeklyGmvProgressCircle
